export default __webpack_public_path__ + "static/media/medaille-qdo-bronze-usage.f1d93f7f.png";